export const TicketType = {
    Batch: "batch",
    ShippingOrder: "shipping_order"
} as const;

export type TicketType = (typeof TicketType)[keyof typeof TicketType];
